import { modifyPageRubricTool } from "./modify-page-rubric";
import { modifyPageTaggedOutcomesTool } from "./modify-page-tagged-outcome";
import { modifyWorksheetTool } from "./modify-worksheet";
import type { ToolNameType, ToolType } from "./types";

export const AVAILABLE_TOOLS: ToolType[] = [
  modifyWorksheetTool,
  modifyPageTaggedOutcomesTool,
  modifyPageRubricTool,
];

export const getSelectedTools = (names: ToolNameType[]): ToolType[] => {
  return AVAILABLE_TOOLS.filter((tool) => names.includes(tool.name));
};
